import { GridCoords } from '../types'

export function normalizeStartAndEndCoords(
  startCoords: GridCoords,
  endCoords: GridCoords,
  gridColsLength: number,
): [GridCoords, GridCoords] {
  return [
    new GridCoords(Math.min(startCoords.x, endCoords.x), Math.min(startCoords.y, endCoords.y), gridColsLength),
    new GridCoords(Math.max(startCoords.x, endCoords.x), Math.max(startCoords.y, endCoords.y), gridColsLength),
  ]
}
